export default {"src":"/_next/static/media/mail-icon.d7eb67b2.svg","height":16,"width":16};